import React, { useMemo } from "react";
import { Select } from "@mantine/core";
import { HallPartOption } from "../../constants/types";

type HallPartsSelectorProps = {
  selectedHallPart?: string;
  readOnly?: boolean;
  onChange: (value: string) => void;
  t: (key: string) => string;
};

const HallPartsSelector: React.FC<HallPartsSelectorProps> = ({
  selectedHallPart,
  readOnly,
  onChange,
  t,
}: HallPartsSelectorProps) => {
  const options: HallPartOption[] = useMemo(() => {
    const storedHallPartsNames = localStorage.getItem("hallPartsNames");
    return storedHallPartsNames ? JSON.parse(storedHallPartsNames) : [];
  }, []);

  const selectedValue = selectedHallPart
    ? options.find((option) => option.labelKey === selectedHallPart)?.value
    : "";

  const handleChange = (value: string | null) => {
    if (value) {
      const selectedPart = options.find((part) => String(part.value) === value);
      if (selectedPart) {
        onChange(selectedPart.value);
      }
    }
  };

  return (
    <Select
      w={"100%"}
      label={t("scheme.redactor.panelOptions.setSector.selectHallPart.label")}
      placeholder={t(
        "scheme.redactor.panelOptions.setSector.selectHallPart.placeholder"
      )}
      data={options.map((option) => ({
        value: option.value,
        label: t(option.labelKey),
      }))}
      onChange={handleChange}
      value={selectedValue}
      readOnly={readOnly}
    />
  );
};

export default React.memo(HallPartsSelector);
